export default __webpack_public_path__ + "static/media/mortal-bg.d301e7c6.png";